/**
 * Custom Horizontal Scrollbar Plugin
 *
 * This script adds a custom horizontal scrollbar to any scrollable container.
 * It supports multiple instances on the page, handles both desktop (mouse drag)
 * and mobile (touch) interactions, and auto-hides when the content fits.
 *
 * Features:
 * - Custom scrollbar track and thumb
 * - Drag-to-scroll functionality
 * - Touch support
 * - Auto show/hide scrollbar based on scrollability
 * - Handles scrollbar track padding correctly
 *
 * Expected HTML structure:
 * <div class="custom-scroll-wrapper">
 *   <div class="custom-scroll-content">
 *     <!-- Wide content here -->
 *   </div>
 *   <div class="custom-scrollbar-track">
 *     <div class="custom-scrollbar-thumb"></div>
 *   </div>
 * </div>
 *
 * CSS styles:
 * .custom-scroll-wrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
}

.custom-scroll-content {
  display: flex;
  overflow-x: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.custom-scroll-content::-webkit-scrollbar {
  display: none;
}

.custom-scrollbar-track {
  display: none;
  position: relative;
  height: 12px;
  background-color: #eee;
}

.custom-scrollbar-thumb {
  height: 100%;
  background: #999;
  border-radius: 6px;
  width: 80px;
  cursor: pointer;
  position: absolute;
  left: 0;
  top: 0;
}
 *
 * Usage:
 * Just include this script after the DOM loads or call initCustomScrollbars() manually.
 *
 * Author:  artem.lytvynenko <artem.lytvynenko@boosta.co>
 * License: MIT
 */
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.custom-scroll-wrapper').forEach(wrapper => {
        const content = wrapper.querySelector('.custom-scroll-content');
        const track = wrapper.querySelector('.custom-scrollbar-track');
        const thumb = wrapper.querySelector('.custom-scrollbar-thumb');

        function getTrackInnerWidth() {
            const style = getComputedStyle(track);
            const paddingLeft = parseFloat(style.paddingLeft);
            const paddingRight = parseFloat(style.paddingRight);
            return track.clientWidth - paddingLeft - paddingRight;
        }

        function getTrackPaddingLeft() {
            return parseFloat(getComputedStyle(track).paddingLeft);
        }

        function updateThumbWidth() {
            const ratio = content.clientWidth / content.scrollWidth;
            const thumbWidth = getTrackInnerWidth() * ratio;
            thumb.style.width = `${thumbWidth}px`;
        }

        function updateThumbPosition() {
            const paddingLeft = getTrackPaddingLeft();
            const ratio = content.scrollLeft / (content.scrollWidth - content.clientWidth);
            const maxLeft = getTrackInnerWidth() - thumb.offsetWidth;
            thumb.style.left = `${paddingLeft + ratio * maxLeft}px`;
        }

        function toggleScrollbarVisibility() {
            if (content.scrollWidth > content.clientWidth) {
                track.style.display = 'block';
                updateThumbWidth();
                updateThumbPosition();
            } else {
                track.style.display = 'none';
            }
        }

        content.addEventListener('scroll', updateThumbPosition);
        window.addEventListener('resize', () => {
            updateThumbWidth();
            updateThumbPosition();
            toggleScrollbarVisibility();
        });

        let isDragging = false;
        let startX;
        let startScrollLeft;

        // Mouse
        thumb.addEventListener('mousedown', function (e) {
            isDragging = true;
            startX = e.pageX;
            startScrollLeft = content.scrollLeft;
            document.body.classList.add('no-select');
        });

        document.addEventListener('mousemove', function (e) {
            if (!isDragging) return;
            const dx = e.pageX - startX;
            const scrollRatio = (content.scrollWidth - content.clientWidth) / (getTrackInnerWidth() - thumb.offsetWidth);
            content.scrollLeft = startScrollLeft + dx * scrollRatio;
        });

        document.addEventListener('mouseup', function () {
            isDragging = false;
            document.body.classList.remove('no-select');
        });

        // Touch
        thumb.addEventListener('touchstart', function (e) {
            isDragging = true;
            startX = e.touches[0].pageX;
            startScrollLeft = content.scrollLeft;
        });

        document.addEventListener('touchmove', function (e) {
            if (!isDragging) return;
            const dx = e.touches[0].pageX - startX;
            const scrollRatio = (content.scrollWidth - content.clientWidth) / (getTrackInnerWidth() - thumb.offsetWidth);
            content.scrollLeft = startScrollLeft + dx * scrollRatio;
        });

        document.addEventListener('touchend', function () {
            isDragging = false;
        });

        toggleScrollbarVisibility(); // init
    });
});
